import { TableFooter, TablePagination, TableRow } from '@material-ui/core';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ITEMS_PER_PAGE, TableFilterContext } from 'tableFilterContext';

export interface PaginatedTableFooterProps {
  total: number;
}

const PaginatedTableFooter: React.FC<PaginatedTableFooterProps> = ({ total }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.tablePagination' });

  const { page, itemsPerPage, dispatch } = useContext(TableFilterContext);
  const setPage = (page: number) => dispatch({ type: 'set_page', payload: page });
  const setItemsPerPage = (itemsPerPage: number) => dispatch({ type: 'set_itemsPerPage', payload: itemsPerPage });

  if (total <= 0 || (page === 1 && total <= itemsPerPage && itemsPerPage === DEFAULT_ITEMS_PER_PAGE)) return <></>;

  return (
    <TableFooter>
      <TableRow>
        {/* @ts-ignore */}
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          labelRowsPerPage={t('labelRowsPerPage')}
          labelDisplayedRows={({ from, to, count }) =>
            t('labelDisplayedRows', {
              from,
              to,
              count,
            })
          }
          nextIconButtonText={t('nextIconButtonText')}
          backIconButtonText={t('backIconButtonText')}
          colSpan={999}
          count={total}
          rowsPerPage={itemsPerPage}
          page={page - 1}
          SelectProps={{
            inputProps: {
              'aria-label': t('labelRowsPerPage'),
            },
            native: true,
          }}
          onPageChange={(e, page) => {
            setPage(page + 1);
          }}
          onRowsPerPageChange={e => {
            setItemsPerPage(Number(e.target.value));
          }}
        />
      </TableRow>
    </TableFooter>
  );
};

export default PaginatedTableFooter;
